import { Save as SaveIcon } from '@mui/icons-material'
import { Button } from '@mui/material'
import { t } from 'i18next'
import { useEffect, useState } from 'react'

import Show from '../../Layout/Can/Show.jsx'
import { useAuth } from '../../Shared/Contexts/AuthContext.jsx'
import { useGlobalContext } from '../../Shared/Contexts/GlobalContext.jsx'
import ZDialog from '../../Shared/Dialogs/ZDialog.jsx'
import { useAutomations } from '../Contexts/AutomationsContext.jsx'
import RuleForm from '../Form/Rule/RuleForm.jsx'

const RuleDetail = ({ isOpen, selectedRuleId, onClose, onEnableEdit, readonly = false }) => {
  const { currentUser } = useAuth()
  const { useUpdateRule, useGetRuleQuery } = useAutomations()
  const { openErrorAlert, openSuccessAlert } = useGlobalContext()
  const [rule, setRule] = useState({
    trigger: null,
    actions: [],
    enabled: true,
    name: ''
  })

  useEffect(() => {
    if (!selectedRuleId) {
      return
    }

    useGetRuleQuery({ id: selectedRuleId }).then((res) => setRule(res.data))
  }, [selectedRuleId])

  const handleOnClose = (reload) => onClose(reload)

  const handleRuleFormChange = (rule) => setRule(rule)

  const handleSaveRule = async () =>
    useUpdateRule({
      id: rule.id,
      payload: {
        organizationKey: rule.organizationKey || currentUser.currentOrganizationKey,
        enabled: rule.enabled,
        name: rule.name,
        triggerId: rule.trigger.id,
        actions: rule.actions.map((x) => ({
          actionId: x.id,
          actionType: x.type
        }))
      }
    })
      .then(() => {
        onClose(true)
        openSuccessAlert()
      })
      .catch((err) => openErrorAlert({ keys: err.data.keys }))

  return (
    <ZDialog
      id={'rule-detail-dialog'}
      maxWidth={'md'}
      isOpen={isOpen}
      onClose={() => handleOnClose(false)}
      title={t('rules.add')}
      content={
        <RuleForm
          onChange={handleRuleFormChange}
          rule={rule}
          isEdit={true}
          readonly={readonly}
        />
      }
      actions={
        <>
          <Show when={() => !readonly}>
            <Button
              id="add-rule-dialog-button-save"
              variant="contained"
              endIcon={<SaveIcon />}
              onClick={handleSaveRule}
              disabled={
                rule.actions.length == 0 ||
            !rule.trigger ||
            !rule.name ||
            (rule.trigger?.type === 'scheduled-trigger' && rule.actions.filter((a) => a.type !== 'downlink').length > 0)
              }>
              {t('common.save')}
            </Button>
          </Show>
          <Show when={() => readonly}>
            <Button
              id="enable-edit-rule"
              variant="contained"
              onClick={onEnableEdit}>
              {t('common.enableEdit')}
            </Button>
          </Show>
        </>
      }
    />
  )
}

export default RuleDetail
